import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CustomService } from '@/shared/services/custom.service';
import { TipoDiplomaResponse, TipoFormacaoResponse } from './formacao.model';

@Injectable({
    providedIn: 'root'
})
/** Service de formação do médico (graduação, pós, diplomas). */
export class FormacaoService extends CustomService {
    private readonly apiUrlTiposFormacao = environment.apis.apiSicom + '/api/v1/cadastro/medico/tipos-formacao/validos';

    private readonly http = inject(HttpClient);

    /**
     * Lista os tipos de formação.
     * GET /api/v1/cadastro/medico/tipos-formacao
     */
    listarTiposFormacao(): Observable<TipoFormacaoResponse[]> {
        return this.http.get<TipoFormacaoResponse[]>(this.apiUrlTiposFormacao).pipe(catchError(this.handleError));
    }

    /**
     * Lista os tipos de diploma por Tipo de Formação.
     * GET /api/v1/cadastro/medico/tipos-formacao/{idTipoFormacao}/diplomas
     */
    listarDiplomasPorTipoFormacao(idTipoFormacao: number): Observable<TipoDiplomaResponse[]> {
        const url = `${this.apiUrlTiposFormacao}/${idTipoFormacao}/diplomas`;
        return this.http.get<TipoDiplomaResponse[]>(url).pipe(catchError(this.handleError));
    }
}
